import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { FormInstance } from 'antd'
import { State } from '../../types/StateType'
import { Nurse } from './types'

const nurseAdapter = createEntityAdapter<Nurse>({
  selectId: (nurse) => nurse.nurseKey,
})

let definedProps: { error: any; loading: boolean; success: any } = {
  error: null,
  loading: false,
  success: null,
}

const initialState = nurseAdapter.getInitialState(definedProps)

const nurseSlice = createSlice({
  name: 'nurse',
  initialState: initialState,
  reducers: {
    getNurse: (state, action: PayloadAction<string>) => {
      state.loading = true
    },
    getNurses: (state) => {
      state.loading = true
    },
    addNurses: (state, action: PayloadAction<Nurse[]>) => {
      state.loading = false
      nurseAdapter.upsertMany(state, action.payload)
    },
    addNurse: (state, action: PayloadAction<Nurse>) => {},
    addNurseSucess: (state, action: PayloadAction<Nurse>) => {
      state.loading = false
      nurseAdapter.addOne(state, action.payload)
    },
    deleteNurse: (state, action: PayloadAction<string>) => {},
    deleteNurseSuccess: (state, action: PayloadAction<string>) => {
      state.loading = false
      const patientIdToDelete = action.payload
      nurseAdapter.removeOne(state, patientIdToDelete)
    },
    updateNurse: (state, action: PayloadAction<Nurse>) => {},
    updateNurseSuccess: (state, action: PayloadAction<Nurse>) => {
      state.loading = false
      nurseAdapter.upsertOne(state, action.payload)
    },
    setNurseForUpdate: (
      state,
      action: PayloadAction<{
        form: FormInstance<any>
        key: string
      }>
    ) => {},
    setNurseForUpdateSuccess: (
      state,
      action: PayloadAction<{
        form: FormInstance<any>
        nurseData: Nurse
      }>
    ) => {
      action.payload.form.setFieldsValue({
        ...action.payload.nurseData,
      })
    },
    updateNurseKey: (state, action: PayloadAction<Nurse>) => {
      state.loading = false
      nurseAdapter.upsertOne(state, action.payload)
    },
    activateNurse: (state, action: PayloadAction<string>) => {},
    changeNurseRole: (
      state,
      action: PayloadAction<{
        id: string
        role: string
      }>
    ) => {},
    errorNurse: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    successNurse: (state, action: PayloadAction<string | null>) => {
      state.success = action.payload
    },
  },
})

export const {
  errorNurse,
  getNurse,
  getNurses,
  addNurse,
  addNurseSucess,
  updateNurse,
  updateNurseSuccess,
  deleteNurse,
  deleteNurseSuccess,
  updateNurseKey,
  addNurses,
  successNurse,
  activateNurse,
  changeNurseRole,
  setNurseForUpdate,
  setNurseForUpdateSuccess,
} = nurseSlice.actions

export default nurseSlice.reducer

const { selectById: selectByKey } = nurseAdapter.getSelectors()

export const selectAllNurses = createSelector(
  (state: State) => state.nurseState,
  (nurses) => Object.values(nurses['entities'])
)

export const selectNurseByKey = (key: string) =>
  createSelector(
    (state: State) => state.nurseState,
    (nurses) => selectByKey(nurses, key)
  )

export const selectErrorInNurse = createSelector(
  (state: State) => state.nurseState.error,
  (error) => error
)
export const selectSuccessInNurse = createSelector(
  (state: State) => state.nurseState.success,
  (success) => success
)

export const selectNurseLoadingState  = createSelector(
  (state: State) => state.nurseState.loading,
  (success) => success
)